import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  userName: any = "Thengarai Maharajan";
  lastRefreshTime: any = '11:11 am';
  getTodayCertificateData: any;
  workFlowDataCount: any;
  getAllUserWorkFlowData: any;
  getDashBoardPolicyCount: any;
  getDashBoardQuotationsCount: any;
  getCertificateCancellation: any;
  private intervalId: any;
  userDetail: any;
  refreshDate: any;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'line'
    },
    title: {
      text: 'My chart'
    }
  };

  constructor(
    private restService: RestService,
    private authService: AuthService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService) {

  }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe((isAuthenticated: boolean | null) => {
      if (isAuthenticated) {
        this.initializeFunctionalities();
      } 
    });
  }
  initializeFunctionalities(): void {
    this.refreshDateFunc();
    this.getMenu();
    this.getDashboard();

    this.intervalId = setInterval(() => {
      this.getDashboard();
      this.refreshDateFunc();
    }, 120000);
  }
  getDashboard() {
    this.loader.show();
    let params = null
    this.loader.show();
    this.restService.postData(params, 'api/Dashboard/GetDashboard').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getDashBoardPolicyCount = data.rObj.Policies;
              this.getDashBoardQuotationsCount = data.rObj.Quotation;
              this.getChart();
            }
            else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      });
  }

  getChart() {
    Highcharts.chart({
      chart: {
        type: 'column',
        renderTo: 'certificateIssuance'
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'category',
        lineWidth: 0, // Set the line width to 0 to remove the x-axis line
        tickWidth: 0,
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' // Set the font family
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        gridLineWidth: 0,

      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          borderRadius: '8px',
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      series: [{
        type: 'column',
        name: 'Count',
        colorByPoint: true,
        data: this.getDashBoardQuotationsCount
      }]
    });
    Highcharts.chart({
      chart: {
        type: 'column',
        renderTo: 'certificateExpiration'
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'category',
        lineWidth: 0, // Set the line width to 0 to remove the x-axis line
        tickWidth: 0,
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' // Set the font family
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        gridLineWidth: 0,

      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          borderRadius: '8px',
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      series: [{
        type: 'column',
        name: 'Count',
        colorByPoint: true,
        data: this.getDashBoardPolicyCount
      }]
    });
    Highcharts.chart({
      chart: {
        type: 'column',
        renderTo: 'certificateCancellation'
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'category',
        lineWidth: 0, // Set the line width to 0 to remove the x-axis line
        tickWidth: 0,
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' // Set the font family
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        gridLineWidth: 0,

      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          borderRadius: '8px',
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      series: [{
        type: 'column',
        name: 'Count',
        colorByPoint: true,
        data: this.getCertificateCancellation
      }]
    });
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  getMenuData() {
    this.loader.show();
    this.restService.postDataDs(null, 'api/digital/core/Module/FetchAllModulesforLogedinRole').subscribe(
      {
        next: (data) => {
          try {
            if (data.rcode === 200) {
              this.userDetail = data.rObj.userDetails;
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            console.error(error);
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      }
    );
  }
  getMenu() {
    this.restService
      .postUADLogin(null, 'api/UAD/FetchAllModulesforLogedInRole')
      .subscribe(
        (data: any) => {
          if (data.rcode == 200) {
            // this.taaasMenuLists = data.rObj.modulesforRole || [];
            // this.taaasMenusToShowCurrently = this.taaasMenuLists.filter(
            //   (ml) => ml.parentModuleID == null
            // );
            // // console.log(this.taaasMenusToShowCurrently);
            // this.userDetails = data.rObj.userDetails;
            // this.firstName =
            //   this.userDetails?.fullName.charAt(0).toUpperCase() +
            //   this.userDetails?.fullName.slice(1);
          }
        },
        (error: any) => {
          this.errorHandler.handleStatusError(error);
        }
      );
  }
  refreshDateFunc() {
    const refreshDate = new Date();
    const year = refreshDate.getFullYear();
    const month = refreshDate.toLocaleString('default', { month: 'short' });
    const date = refreshDate.getDate().toString().padStart(2, '0');
    const hours = refreshDate.getHours().toString().padStart(2, '0');
    const minutes = refreshDate.getMinutes().toString().padStart(2, '0');
    const formattedDate = `${date}-${month}-${year} ${hours}:${minutes}`;
    this.lastRefreshTime = formattedDate;
  }

}
